import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import MachineBrigadeDt from '@/services/dataTransferModules/machineBrigadeDt'

const machineBrigadeDt = new MachineBrigadeDt()

export default function useMachineBrigades() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: brigades,
		getEntities: getMachineBrigades,

		entity: brigade,
		getEntity: getMachineBrigade,

		createEntity: createMachineBrigade,
		patchEntity: updateMachineBrigade,
		updateEntity: fullUpdateMachineBrigade,
		deleteEntity: deleteMachineBrigade,
	} = useBlProviders(machineBrigadeDt, {
		hasParentEntity: true,

		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error loading brigades'),

		showErrorNotificationForLoadingOneEntity: true,

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Brigade loading error'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Brigade editing error'),

		showErrorNotificationForDeletingEntity: true,
	})

	return {
		flags,
		brigades,
		brigade,
		getMachineBrigades,
		getMachineBrigade,
		createMachineBrigade,
		deleteMachineBrigade,
		updateMachineBrigade,
		fullUpdateMachineBrigade,
	}
}
